import axios from 'axios';

import { axiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const addClubShipmentItem = (customerId, shipmentId, item) =>
  axios.post(
    `${getV1RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/item`,
    item,
    axiosHeader()
  );

export const exchangeClubShipmentItem = (
  customerId,
  shipmentId,
  productVariantId,
  item
) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/item/${productVariantId}/exchange`,
    item,
    axiosHeader()
  );

export const editClubShipmentItem = (
  customerId,
  shipmentId,
  productVariantId,
  item
) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/item/${productVariantId}`,
    item,
    axiosHeader()
  );

export const deleteClubShipmentItem = (
  customerId,
  shipmentId,
  productVariantId
) =>
  axios.delete(
    `${getV1RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/item/${productVariantId}`,
    axiosHeader()
  );

export const processClubShipment = (customerId, shipmentId) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/process`,
    null,
    axiosHeader()
  );

export const skipClubShipment = (customerId, shipmentId) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/skip`,
    null,
    axiosHeader()
  );

export const unskipClubShipment = (customerId, shipmentId) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/club-subscription-shipment/${shipmentId}/unskip`,
    null,
    axiosHeader()
  );
